import { caseAnalyticsApi, getCasesListApi, getCasesListInMonthsApi, getCasesListInYearsApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useState ,useEffect} from 'react'
import AnalyticCasesCard from './AnalyticCasesCard';
import TimeframeHeader from './TimeframeHeader';
import moment from 'moment';

function CasesAnalytics({activePanel}) {
  const {makeApiCallFunc} = useContext(Context);
  const [caseData, setCaseData] = useState(null);
  const [frame, setFrame] = useState("today");
  const [loadCaseAnalytics, setLoadCaseAnalytics] = useState(true);
  const [xAxisValues, setXAxisValues] = useState([]);
  const [values, setValues] = useState([]);
  const [totalCount, setTotalCount] = useState();


const [dateRange, setDateRange] = useState([
  {
    startDate: new Date(Date.now()),
    endDate: new Date(Date.now()),
    key: 'selection'
  }
]);
const transformResponseForGraph = (data)=> {
  console.log(data);
  getDatesBetween(data)
}
const getDatesBetween = (data) =>{
  const dates = [];
  let values = {
    "created" : [],
    "closed" : [],
    "requests" : []
  };
  let currentDate = moment(dateRange[0]?.startDate);
  const finalDate = moment(dateRange[0]?.endDate);
  const count = {
    "created": data?.created?.length,
    "closed" : data?.closed?.length,
    "requests": data?.requests?.length
  }
  while (currentDate <= finalDate) {
    dates.push(moment(currentDate).format("MM-DD-YYYY"));
    values.created.push(getValues(currentDate, "created", "created_at", data));
    values.closed.push(getValues(currentDate, "closed", "updated_at", data));
    values.requests.push(getValues(currentDate, "requests", "created_at", data));
    currentDate = moment(currentDate).add(1, "days");
  }
  setXAxisValues(dates);
  setValues(values);
  setTotalCount(count);
  console.log(values);
  return dates;
}
const getValues = (currentDate, arrayName, compareField, data) => {
    var count = 0;
    const date2 = moment(currentDate);
    data?.[arrayName]?.map((item) => {
    const date1 = moment(item?.[compareField]);
  
    const areDatesSame = date1.isSame(date2, "day"); // Change "day" to "date" if you want to compare the dates down to the millisecond
    if(areDatesSame)
    { count ++;}
  })

  return count;
}
  useEffect(() => {
    
    const startTime = dateRange[0]?.startDate;
    const endTime = dateRange[0]?.endDate;
      if(isMoreThan60Days())
      {
        const startMonth = startTime?.getMonth() + 1; // Adding 1 to get the month in the range 1-12
        const year = startTime.getFullYear();
        const endMonth = endTime.getMonth() + 1;
        const endyear = endTime.getFullYear();
        if(year === endyear)
        {
          makeApiCallFunc(getCasesListInMonthsApi,
            {
              startMonth,
              endMonth,
              year
            },
            ({data})=> {
              setCaseData(data);
              console.log(data);
              transformResponseForMonthsGraph(data);
            },
            (data) => console.log(data)
            )
        }
        else
        {
          makeApiCallFunc(getCasesListInYearsApi,
            {
              startYear:year,
              endYear: endyear
            },
            ({data})=> {
              setCaseData(data);
              transformResponseForMonthsGraph(data);
            },
            (data) => console.log(data)
            )
        }
       
      }
      else
      {
        makeApiCallFunc(getCasesListApi,
          {
            startTime : startTime,
            endTime : endTime
          },
          ({data})=> {
            setCaseData(data);
            transformResponseForGraph(data);
          },
          (data) => console.log(data)
          )
      }
  }, [loadCaseAnalytics])
  const transformResponseForMonthsGraph = (data) => {
    const dates = [];

    const values = {
      "created":[],
      "closed" : [],
      "requests":[]
    };
    const count = {
      "created": 0,
      "closed" : 0,
      "requests":0
    }
    data.map((d)=>
    {
      dates.push(Object.entries(d)[0][0]);
      values.created.push(Object.entries(d)[0][1].created);
      values.closed.push(Object.entries(d)[0][1].closed);
      values.requests.push(Object.entries(d)[0][1].requests);
      count.created = Object.entries(d)[0][1].created + count.created;
      count.closed = Object.entries(d)[0][1].closed + count.closed;
      count.requests = Object.entries(d)[0][1].requests + count.requests;

    })
    setValues(values);
    setXAxisValues(dates);
    setTotalCount(count);
  }
  const isMoreThan60Days = () => {
    const date1 = moment(dateRange[0]?.startDate);
    const date2 = moment( dateRange[0]?.endDate);
    const differenceInDays = date2.diff(date1, 'days');

    // Check if the difference is more than 60 days
    const moreThan60DaysApart = differenceInDays > 60;
   
    return moreThan60DaysApart;
  }
  const isSingleDay = () => {
    const date1 = moment(dateRange[0]?.startDate);
    const date2 = moment( dateRange[0]?.endDate);

    // Compare if the two dates are the same
    const areDatesSame = date1.isSame(date2, "date"); // Change "day" to "date" if you want to compare the dates down to the millisecond
    return areDatesSame
  }
  const rangeLabel = isSingleDay()
    ? moment(dateRange[0]?.startDate).format('MMM D, YYYY')
    : moment(dateRange[0]?.startDate).format('MMM D') + ' – ' + moment(dateRange[0]?.endDate).format('MMM D, YYYY');

  return (
    <div className='w-full font-plexsans'>
      <div className='flex flex-wrap items-center justify-between gap-3' style={{ marginBottom: '24px' }}>
        <div style={{ fontSize: '12.5px', color: 'rgba(20,33,61,.5)' }}>
          Showing <span style={{ color: '#14213d', fontWeight: 500 }}>{rangeLabel}</span>
        </div>
        <TimeframeHeader className='flex items-center' setLoadCaseAnalytics={setLoadCaseAnalytics} frame={frame} setFrame={setFrame} setDateRange={setDateRange} dateRange={dateRange}/>
      </div>
      <AnalyticCasesCard
        totalCount={totalCount}
        xAxisValues={xAxisValues}
        values={values}
        rangeLabel={rangeLabel}
      />
    </div>
  )
}

export default CasesAnalytics